// this is adminformvalidation.ts and in this make validations for name ,email

// validation functions for personalinfoform
export const validatePhone = (phone: string): string => {
    const trimmedPhone = phone.trim();
  
    if (trimmedPhone.length === 0) {
      return "Phone number cannot be empty";
    }
  
    if (!/^\d+$/.test(trimmedPhone)) {
      return "Phone number must be numeric";
    }
  
    if (trimmedPhone.length < 3) {
      return "Phone number cannot be less than 3 digits";
    }
  
    if (trimmedPhone.length > 10) {
      return "Phone number cannot be more than 10 digits";
    }
  
    if (trimmedPhone.length < 10) {
      return "Phone number must be 10 digits";
    }
  
    return "";
  };
  
  export const validateEmail = (email: string): string => {
    const trimmedEmail = email.trim();
  
    if (trimmedEmail.length === 0) {
      return "Email cannot be empty";
    }
  
    // Basic email pattern check
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(trimmedEmail)) {
      return "Invalid email address";
    }
  
    return "";
  };




// validation functions for storedetails.tsx


